/** Order identity uses lifetime game counters, never rewards granted by the order itself. */
export type Order = 'quill' | 'paw';
export type OrderSlot = 'road' | 'cards' | 'combat';
export interface OrderProgress { steps: number; owned: number; relics: number; arenaWins: number; raceWins: number; bestCombo: number }
interface GoalDef { id: OrderSlot; metric: keyof OrderProgress; target: number; route: string }
const GOALS: Record<Order, readonly GoalDef[]> = {
  quill: [
    { id: 'road', metric: 'steps', target: 12, route: '#/road' },
    { id: 'cards', metric: 'owned', target: 18, route: '#/cards/collection' },
    { id: 'combat', metric: 'relics', target: 2, route: '#/road' },
  ],
  paw: [
    { id: 'road', metric: 'arenaWins', target: 3, route: '#/arena' },
    { id: 'cards', metric: 'raceWins', target: 1, route: '#/snails' },
    { id: 'combat', metric: 'bestCombo', target: 3, route: '#/arena' },
  ],
};
/** The legacy slot IDs are deliberately retained: an already paid slot stays paid. */
export function orderGoals(order: Order, progress: OrderProgress, claims: readonly string[] = []) {
  return GOALS[order].map(goal => {
    const value = progress[goal.metric];
    const n = Number.isFinite(value) ? Math.max(0, Math.floor(value)) : 0;
    const claimed = claims.includes(goal.id);
    return { ...goal, n, claimed, ready: !claimed && n >= goal.target, key: `explore.goal.${goal.metric}` };
  });
}
